export type PersianSection = {
  title: string;
  body: string;
  items?: string[];
  email?: string;
};

export type PersianPageDefinition = {
  path: string;
  title: string;
  metaTitle: string;
  description: string;
  kicker: string;
  heroImage?: { src: string; mobileSrc: string; alt: string };
  sections: PersianSection[];
  cta?: { label: string; href: string; text: string };
  alternatePath?: string;
};

export const persianValueItems = [
  { title: "معرفی حرفه‌ای در بازار بین‌المللی", body: "اطلاعات شرکت، محصولات و توانمندی‌های تولیدی به شکلی متناسب با مخاطب بین‌المللی ارائه می‌شود." },
  { title: "دسترسی به درخواست‌های خرید", body: "درخواست‌های مرتبط با محصولات و صنایع تحت پوشش بررسی و در صورت تناسب به تأمین‌کنندگان مرتبط منتقل می‌شوند." },
  { title: "ارتباط با خریداران", body: "IranTradeReach مسیر ارتباط اولیه میان تولیدکننده و خریداران بالقوه بین‌المللی را تسهیل می‌کند." },
  { title: "آماده‌سازی اطلاعات تجاری", body: "اطلاعات معرفی محصول، مشخصات فنی و محتوای تجاری برای حضور حرفه‌ای‌تر در بازار خارجی ساختاردهی می‌شود." },
  { title: "توسعه بازار", body: "بازارها، صنایع و فرصت‌های مرتبط با محصولات شرکت به‌صورت هدفمند بررسی می‌شوند." },
] as const;

export const persianIndustries = [
  { id: "steel", title: "فولاد و محصولات فولادی", body: "میلگرد، بیلت و دیگر محصولات فولادی موجود در شبکه فعلی." },
  { id: "minerals", title: "معدن و مواد معدنی", body: "سنگ معدن، کنسانتره، فروآلیاژها و مواد کربنی." },
  { id: "machinery", title: "تجهیزات و ماشین‌آلات صنعتی", body: "تجهیزات صنعتی متناسب با مشخصات فنی و کاربرد موردنیاز." },
  { id: "pumps", title: "پمپ و تجهیزات انتقال سیالات", body: "پمپ‌های صنعتی، کشاورزی، ساختمانی و تجهیزات مرتبط." },
  { id: "parts", title: "قطعات و تجهیزات صنعتی", body: "قطعات و ملزومات صنعتی که امکان ارزیابی و تأمین آنها وجود دارد." },
  { id: "agriculture", title: "کشاورزی و صنایع غذایی", body: "محصولات کشاورزی و تازه با بررسی فصل، درجه‌بندی، بسته‌بندی و مقصد." },
] as const;

export const persianProcess = [
  { title: "معرفی شرکت", body: "اطلاعات پایه شرکت، محصولات و مسیر موردنظر برای توسعه بازار را ارسال می‌کنید." },
  { title: "بررسی محصولات و ظرفیت صادراتی", body: "تناسب محصول، مدارک موجود، ظرفیت پاسخ‌گویی و آمادگی تجاری بررسی می‌شود." },
  { title: "تکمیل اطلاعات و محتوای تجاری", body: "اطلاعات فنی و معرفی شرکت برای ارائه روشن‌تر به مخاطب خارجی ساختاردهی می‌شود." },
  { title: "معرفی در IranTradeReach", body: "ظرفیت‌های تأییدشده در بخش‌ها و ارتباطات مرتبط IranTradeReach معرفی می‌شوند." },
  { title: "دریافت و بررسی فرصت‌های تجاری", body: "درخواست‌ها و فرصت‌های مرتبط بررسی و در صورت تناسب با شرکت در میان گذاشته می‌شوند." },
  { title: "ارتباط مستقیم برای مذاکره", body: "پس از تأیید اولیه، مسیر ارتباط برای بررسی فنی و مذاکره تجاری میان طرفین فراهم می‌شود." },
] as const;

export const persianPages: PersianPageDefinition[] = [
  {
    path: "/fa/about",
    alternatePath: "/about",
    title: "درباره IranTradeReach",
    metaTitle: "درباره IranTradeReach | ارتباط تولیدکنندگان ایرانی با بازارهای جهانی",
    description: "IranTradeReach با تمرکز بر معرفی هدفمند ظرفیت‌های تولیدی ایران و ایجاد ارتباط حرفه‌ای با بازارهای بین‌المللی فعالیت می‌کند.",
    kicker: "تجارت بین‌الملل با تمرکز بر ظرفیت ایران",
    heroImage: { src: "/images/about-hero-sourcing-team.webp", mobileSrc: "/images/about-hero-sourcing-team-800.webp", alt: "بررسی توانمندی‌های تولیدی و اطلاعات تجاری برای بازار بین‌المللی" },
    sections: [
      { title: "تمرکز ما", body: "IranTradeReach برای ایجاد ارتباط هدفمند میان تولیدکنندگان ایرانی و خریداران خارجی شکل گرفته است. کار ما از شناخت دقیق محصول و ظرفیت شرکت آغاز می‌شود و بر ارائه اطلاعات قابل اتکا به مخاطب بین‌المللی تمرکز دارد." },
      { title: "شیوه همکاری", body: "هر همکاری براساس اطلاعات واقعی شرکت، مشخصات فنی محصول و هدف بازار تعریف می‌شود. پیش از هر معرفی، تناسب محصول و آمادگی تجاری بررسی خواهد شد.", items: ["بررسی اطلاعات شرکت و محصول", "ساختاردهی محتوای فنی و تجاری", "ارزیابی بازارها و فرصت‌های مرتبط", "ایجاد مسیر ارتباط برای گفت‌وگوی مستقیم"] },
      { title: "مرز مسئولیت", body: "IranTradeReach فروش یا صادرات را تضمین نمی‌کند و صرفاً با ارسال فرم، نماینده انحصاری، خریدار یا طرف معامله شرکت نخواهد بود. شرایط نهایی هر همکاری و معامله باید میان طرف‌های مرتبط بررسی و توافق شود." },
    ],
  },
  {
    path: "/fa/industries",
    title: "صنایع و حوزه‌های فعالیت",
    metaTitle: "صنایع تحت پوشش | IranTradeReach",
    description: "حوزه‌های صنعتی و محصولاتی که در حال حاضر امکان بررسی برای معرفی و توسعه بازار بین‌المللی آنها در IranTradeReach وجود دارد.",
    kicker: "حوزه‌های فعلی",
    heroImage: { src: "/images/product-directory-hero.webp", mobileSrc: "/images/product-directory-hero-800.webp", alt: "میلگرد، بیلت فولادی و پمپ صنعتی" },
    sections: persianIndustries.map((industry) => ({ title: industry.title, body: industry.body })),
    cta: { label: "معرفی شرکت و محصولات", href: "/fa/suppliers/join", text: "اگر محصول شما در این حوزه‌ها قرار دارد، اطلاعات شرکت و محصولات را برای بررسی ارسال کنید." },
  },
  {
    path: "/fa/suppliers",
    alternatePath: "/for-manufacturers",
    title: "همکاری با تولیدکنندگان و تأمین‌کنندگان ایرانی",
    metaTitle: "همکاری با تولیدکنندگان ایرانی | IranTradeReach",
    description: "شرایط و مسیر همکاری تولیدکنندگان و تأمین‌کنندگان ایرانی با IranTradeReach برای معرفی حرفه‌ای در بازارهای بین‌المللی.",
    kicker: "توسعه بازار صادراتی",
    heroImage: { src: "/images/manufacturers-hero.webp", mobileSrc: "/images/manufacturers-hero-800.webp", alt: "بررسی محصولات و ظرفیت تولید در یک مجموعه صنعتی" },
    sections: [
      { title: "این همکاری برای چه شرکت‌هایی مناسب است؟", body: "تولیدکنندگانی که محصول مشخص، اطلاعات فنی قابل ارائه، ظرفیت پاسخ‌گویی و نگاه واقع‌بینانه به توسعه بازار خارجی دارند می‌توانند برای بررسی همکاری اقدام کنند." },
      { title: "چه اطلاعاتی بررسی می‌شود؟", body: "ارزیابی اولیه براساس وضعیت واقعی شرکت انجام می‌شود.", items: ["محصولات اصلی و مزیت‌های قابل اثبات", "ظرفیت تولید و امکان پاسخ‌گویی", "مدارک فنی و گواهی‌های موجود", "سابقه صادرات یا آمادگی برای شروع", "بازارها و مشتریان هدف"] },
      { title: "نتیجه بررسی اولیه", body: "پس از بررسی اطلاعات، درباره تناسب همکاری و گام بعدی با شرکت تماس می‌گیریم. ارسال اطلاعات به‌تنهایی به معنی پذیرش قطعی، تضمین معرفی یا تضمین فروش نیست." },
    ],
    cta: { label: "معرفی شرکت", href: "/fa/suppliers/join", text: "اطلاعات شرکت و محصولات خود را برای ارزیابی اولیه ارسال کنید." },
  },
  {
    path: "/fa/contact",
    alternatePath: "/contact",
    title: "تماس با IranTradeReach",
    metaTitle: "تماس با ما | IranTradeReach",
    description: "برای همکاری تولیدکنندگان، پرسش‌های تجاری و پیگیری مکاتبات با تیم IranTradeReach در ارتباط باشید.",
    kicker: "ارتباط با ما",
    heroImage: { src: "/images/services-hero-sourcing.webp", mobileSrc: "/images/services-hero-sourcing-800.webp", alt: "بررسی اطلاعات تجاری و هماهنگی برای ارتباط با تیم IranTradeReach" },
    sections: [
      { title: "همکاری تولیدکنندگان", body: "برای معرفی شرکت و بررسی ظرفیت صادراتی از فرم همکاری استفاده کنید.", email: "partners@irantradereach.ir" },
      { title: "پرسش‌های عمومی", body: "برای پرسش‌های عمومی یا هماهنگی اولیه با ما مکاتبه کنید.", email: "info@irantradereach.ir" },
      { title: "پیگیری درخواست‌های قبلی", body: "اگر قبلاً درخواست یا مدرکی ارسال کرده‌اید، شماره پیگیری را در پیام خود بنویسید.", email: "support@irantradereach.ir" },
    ],
  },
  {
    path: "/fa/privacy-policy",
    title: "حریم خصوصی",
    metaTitle: "سیاست حفظ حریم خصوصی | IranTradeReach",
    description: "نحوه دریافت، استفاده و نگهداری اطلاعاتی که از طریق فرم‌های فارسی IranTradeReach ارسال می‌شود.",
    kicker: "اطلاعات حقوقی",
    sections: [
      { title: "اطلاعات دریافتی", body: "اطلاعاتی که در فرم‌ها وارد می‌کنید، از جمله نام، اطلاعات تماس، مشخصات شرکت، محصولات و توضیحات تجاری برای بررسی درخواست و پاسخ‌گویی دریافت می‌شود." },
      { title: "نحوه استفاده", body: "اطلاعات برای ارزیابی درخواست، تماس با شما و بررسی امکان همکاری استفاده می‌شود و در صورت لزوم تنها اطلاعات مرتبط با فرصت مشخص در اختیار طرف‌های مرتبط قرار می‌گیرد." },
      { title: "انتخاب شما", body: "برای درخواست دسترسی، اصلاح یا حذف اطلاعات ارسالی می‌توانید با واحد پشتیبانی تماس بگیرید.", email: "support@irantradereach.ir" },
    ],
  },
  {
    path: "/fa/terms-of-use",
    title: "شرایط استفاده",
    metaTitle: "شرایط استفاده | IranTradeReach",
    description: "شرایط استفاده از نسخه فارسی وب‌سایت IranTradeReach و اطلاعات مرتبط با همکاری تجاری.",
    kicker: "اطلاعات حقوقی",
    sections: [
      { title: "ماهیت اطلاعات", body: "مطالب سایت برای معرفی خدمات و بررسی اولیه فرصت‌های همکاری ارائه شده‌اند. مشخصات محصول، ظرفیت، قیمت و شرایط تجاری باید در هر مورد جداگانه تأیید شوند." },
      { title: "عدم ایجاد تعهد خودکار", body: "ارسال فرم یا مکاتبه از طریق سایت به‌تنهایی موجب ایجاد قرارداد، تعهد خرید، تضمین فروش، نمایندگی یا رابطه انحصاری نمی‌شود." },
      { title: "مسئولیت طرف‌ها", body: "تولیدکنندگان، خریداران و ارائه‌دهندگان خدمات مسئول اطلاعات، کالاها، خدمات و تعهدات قراردادی خود هستند." },
    ],
  },
];
